(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/sorter/balls.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/sorter/balls.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.row = svs.tur.row || {};
svs.tur.row.sorter = svs.tur.row.sorter || {};
svs.tur.ball.row.sorter.constants = {
  DRAW_ORDER: 'sort:drawOrder',
  NUMERICAL: 'sort:numerical'
};

class Balls extends svs.tur.ball.row.sorter.Sorter {
  constructor(_ref) {
    let {
      elements
    } = _ref;
    super();
    this.elements = elements;
  }
  sort() {
    let order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : svs.tur.ball.row.sorter.constants.NUMERICAL;
    let animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (order === svs.tur.ball.row.sorter.constants.NUMERICAL) {
      this.sortNumerical(animate);
    } else {
      this.sortDrawOrder(animate);
    }
  }
  sortDrawOrder() {
    let animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    const tempElements = [...this.elements];
    tempElements.sort((a, b) => a.initIndex - b.initIndex);
    this.elements = tempElements;
    this._sort(animate);
  }
  sortNumerical() {
    let animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    const tempElements = [...this.elements];
    tempElements.sort((a, b) => a.number - b.number);
    this.elements = tempElements;
    this._sort(animate);
  }
  _sort(animate) {
    if (!this.elements[0].hasOwnProperty('x')) {
      this._updateProperties();
    }
    this.elements.forEach((ball, i) => {
      gsap.set(ball.$el, {
        order: i + 1
      });
    });
    if (animate) {
      this._animate();
    }
  }
  _updateProperties() {
    this.elements.forEach(ball => {
      gsap.set(ball.$el, {
        x: 0,
        y: 0
      });
      const ballProps = ball.$el;
      ball.x = ballProps.offsetLeft;
      ball.y = ballProps.offsetTop;
    });
  }
  _animate() {
    if (!this.elements[0].hasOwnProperty('x')) {
      this._updateProperties();
    }
    this.elements.forEach(ball => {
      const ballProps = ball.$el;
      const lastX = ball.x,
        lastY = ball.y;
      ball.x = ballProps.offsetLeft;
      ball.y = ballProps.offsetTop;
      const x = gsap.getProperty(ballProps, 'x') + lastX - ball.x,
        y = gsap.getProperty(ballProps, 'y') + lastY - ball.y,
        gotoX = x + _.random(-20, 20),
        gotoY = y + _.random(-50, 50);

      const tl = new gsap.timeline();
      tl.fromTo(ball.$el, 0.3, {
        x,
        y
      }, {
        x: gotoX,
        y: gotoY
      });
      tl.to(ball.$el, 0.5, {
        x: 0,
        y: 0,
        ease: Back.easeOut
      });
    });
  }
}
svs.tur.ball.row.sorter.Balls = Balls;

 })(window);